import { getAdditionalSalesService } from '../services/AdditionalSalesService'
import { useCallback, useEffect, useState } from 'react'

export const useAdditionalSales = () => {
    const [additionalSales, setAdditionalSales] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const refresh = useCallback(async () => {
        setLoading(true)
        try {
            const response = await getAdditionalSalesService()

            if (!response || response.status !== 200) {
                throw new Error(`Error fetching additional sales: ${response?.statusText ?? 'Unknown error'}`)
            }

            const data = response.data

            if (!data) {
                throw new Error('No data received from the server')
            }

            setAdditionalSales(data)
            setError(null)
        } catch (err) {
            setError(err.message || String(err))
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => {
        refresh()
    }, [refresh])

    return { additionalSales, loading, error, refresh }
}
